import { render } from "./SocialIcon.vue?vue&type=template&id=4b75778d&scoped=true"
import script from "./SocialIcon.vue?vue&type=script&lang=js"
export * from "./SocialIcon.vue?vue&type=script&lang=js"

import "./SocialIcon.vue?vue&type=style&index=0&id=4b75778d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b75778d"]])

export default __exports__